module.exports = __webpack_public_path__ + "img/organizationInfo.36e1d464.svg";